import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { RouterKeys } from "./RouterKeys";

const NonAuthProtect = ({ children }) => {
    const accessToken = useSelector((state) => state?.auth?.adminToken);

    // Redirect authenticated users to the dashboard
    if (accessToken) {
        return children;
    }

    return <Navigate to={RouterKeys.AUTH.LOGIN} />;
};

export default NonAuthProtect;
